import * as yup from "yup"
import { t } from "../../languages/i18n"

export const loginSchema = yup.object().shape({
  email: yup.string().email("Invalid email address").required(t("Please enter email!")),
  password: yup.string().required(t("Please enter password!")),
})

export const forgotPasswordSchema = yup.object().shape({
  email: yup.string().email("Invalid email address").required(t("Please enter email!")),
})

export const resetPasswordSchema = yup.object().shape({
  password: yup
    .string()
    .min(6, t("Password must be at least 6 characters"))
    .required(t("Please enter password!")),
  passwordConfirmation: yup
    .string()
    .oneOf([yup.ref("password")], t("Passwords do not match"))
    .required(t("Please confirm your password!")),
})

export const changePasswordSchema = yup.object().shape({
  currentPassword: yup.string().required(t("Please enter your current password!")),
  password: yup
    .string()
    .min(6, t("Password must be at least 6 characters"))
    .notOneOf([yup.ref("currentPassword")], t("New password must be different from the current password"))
    .required(t("Please enter password!")),
  passwordConfirmation: yup
    .string()
    .oneOf([yup.ref("password")], t("Passwords do not match"))
    .required(t("Please confirm your password!")),
})
